"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../../RenderIf"));

var _icon = _interopRequireDefault(require("../../Option/icon"));

var _styled = require("./styled");

var _hooks = require("./hooks");

var CountriesList = /*#__PURE__*/(0, _react.memo)(function (props) {
  var countries = props.countries,
      country = props.country,
      itemsRef = props.itemsRef,
      handleCountryChange = props.handleCountryChange,
      handleActiveChange = props.handleActiveChange;
  var list = (0, _hooks.useSimulatedLoading)(countries, 15);
  return list.map(function (value, index) {
    var isoCode = value.isoCode,
        name = value.country,
        countryCode = value.countryCode,
        flagIcon = value.flagIcon;
    var isSelected = value === country;
    var formattedCountryCode = "(".concat(countryCode, ")");
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledItem, {
      key: isoCode,
      ref: function ref(elem) {
        itemsRef.current[index] = elem;
        return itemsRef.current[index];
      },
      onClick: function onClick() {
        return handleCountryChange(value);
      },
      onMouseEnter: function onMouseEnter() {
        return handleActiveChange(index);
      },
      role: "option",
      "aria-selected": false,
      isSelected: isSelected
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      icon: flagIcon,
      isVisible: true,
      position: "left"
    }), name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_styled.StyledCountryCodeItem, null, formattedCountryCode), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
      isTrue: isSelected
    }, /*#__PURE__*/_react["default"].createElement(_styled.StyledCheckmarkIcon, null))));
  });
});
CountriesList.propTypes = {
  countries: _propTypes["default"].array,
  country: _propTypes["default"].object,
  itemsRef: _propTypes["default"].object,
  handleCountryChange: _propTypes["default"].func,
  handleActiveChange: _propTypes["default"].func
};
CountriesList.defaultProps = {
  countries: [],
  country: undefined,
  itemsRef: [],
  handleCountryChange: function handleCountryChange() {},
  handleActiveChange: function handleActiveChange() {}
};
var _default = CountriesList;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/PhoneInput/countriesDropdown/countriesList.js
// module id = qsp8
// module chunks = 0